import React from "react";
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const OrderBlockInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
          <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is an Order Block?</h4>
          <p>
            An Order Block is a consolidation area on a price chart where large institutional traders execute bulk buy
            or sell orders. These areas often appear before significant price movements and are considered zones of
            high interest in the market.
          </p>
          <p>
            <b>Why is it important to traders?</b> Order blocks serve as key levels where price may react due to the
            residual orders left in the market. Understanding order blocks helps traders:
          </p>
          <ul>
            <li>Identify areas of potential price reversals or continuations.</li>
            <li>Anticipate institutional trading behavior.</li>
            <li>Place trades with favorable risk-to-reward ratios.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Types of Order Blocks</h4>
          <p>
            <b>Bearish Order Blocks:</b> These form when price consolidates and drops, creating a resistance zone.<br />
            <b>Bullish Order Blocks:</b> These form when price consolidates and rallies, creating a support zone.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. How to Identify Order Blocks</h4>
          <p>
            <b>Consolidation Zones:</b> Look for areas where price moves sideways before a sharp move up or down.<br />
            <b>Breakouts:</b> Order blocks are validated when price breaks out strongly from the consolidation area.<br />
            <b>Volume Spikes:</b> High volume in the order block area indicates strong institutional activity.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Trading Around Order Blocks</h4>
          <p>
            Traders use order blocks to anticipate price reactions. Key strategies include:
          </p>
          <ul>
            <li>Placing limit orders within the block to catch potential retracements.</li>
            <li>Waiting for confirmation (e.g., candlestick patterns) before entering trades.</li>
            <li>Using order blocks as stop-loss levels for enhanced risk management.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Retesting Order Blocks</h4>
          <p>
            After a breakout, price often returns to retest the order block before continuing in the breakout direction.
            This provides traders with an opportunity to enter at a favorable price point.
          </p>
          <p>
            <b>Usage:</b> Look for retests on lower timeframes for precision entries.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderBlockInfo;
